<strong>&copy; NitroPay</strong>
<span>|</span>
<a routerLink="/terms">Terms of Use</a>
<span>|</span>
<a href="https://nitropay.com/privacy" target="_blank">Privacy Policy</a>
<span>|</span>
<a href="javascript:;" (click)="openSupportModal()">Payment Support</a>
